export default __webpack_public_path__ + "static/media/img_step_situation01.49b586e7.jpg";